'use client'

import { useEffect } from 'react'
import i18n, { syncLocaleFromStorage } from '@/i18n'
import { isRtlLocale, LOCALE_BY_CODE, type AppLocale } from '@/i18n/localeConfig'

function applyDocumentLocale(locale: string) {
  const base = locale.split('-')[0] as AppLocale
  const def = LOCALE_BY_CODE[base]
  document.documentElement.lang = def?.languageTag ?? locale
  document.documentElement.dir = isRtlLocale(base) ? 'rtl' : 'ltr'
}

const LocaleSync = () => {
  useEffect(() => {
    syncLocaleFromStorage()

    const handleLanguageChanged = (locale: string) => {
      applyDocumentLocale(locale)
    }

    i18n.on('languageChanged', handleLanguageChanged)
    return () => {
      i18n.off('languageChanged', handleLanguageChanged)
    }
  }, [])

  return null
}

export default LocaleSync
